@if (control; as control) {
  <div class='row'>
    <div class='col-12'>
      <div>
        Geometria @if (isRequired) {
        *
      }:&nbsp;
        <button
          *ngIf='!showDrawTerrain && !control.value?.length'
          type='button'
          class='btn btn-secondary'
          (click)='showDrawTerrain = true'>
          <i class='fa fa-map' aria-hidden='true'></i>
          <span aria-hidden='true'>Dodaj</span>
          <span class='sr-only'>Dodaj geometrie</span>
        </button>
        <button
          *ngIf='!showDrawTerrain && !!control.value?.length'
          type='button'
          class='btn btn-secondary'
          (click)='showDrawTerrain = true'>
          <i class='fa fa-map-marked' aria-hidden='true'></i>
          <span aria-hidden='true'>Edytuj</span>
          <span class='sr-only'>Edytuj geometrie</span>
        </button>
        @if (control.invalid && control.touched) {
          <span class='d-inline-block ms-3 mt-3'>
            <app-alert type='danger' [closable]='false'>Pole jest wymagane</app-alert>
          </span>
        }
      </div>
      <br>
      @if (alertMessage) {
        <app-alert type="info" [closable]="false">
          {{ alertMessage }}
        </app-alert>
      }
      @if (showDrawTerrain) {
        <br>
        <div>
          <app-exposed-map
            [serviceId]="serviceId()"
            (dictionary)="dictionary.emit($event)"
            [formControl]="control"
            (close)="showDrawTerrain = false">
          </app-exposed-map>
        </div>
      }
    </div>
  </div>
}
